// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__iY6BU","small":"styles_small__k0s0-"};